module.exports = __webpack_public_path__ + "static/Josh_2_min-d2331c872a642f09718f8c52e7e36e63.jpg";